// @flow

export const LOAD_INIT = 'LOAD_INIT'
export const LOAD_SUCCESS = 'LOAD_SUCCESS'
export const LOAD_ERROR = 'LOAD_ERROR'
